import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=71ea4567&scoped=true"
import script from "./Integrations.vue?vue&type=script&lang=ts"
export * from "./Integrations.vue?vue&type=script&lang=ts"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=71ea4567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ea4567",
  null
  
)

export default component.exports